import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Icon} from 'kpc';

var _$tmp0 = {
    'className': 'ion-happy-outline',
    'disabled': true
};
var _$tmp1 = {
    'className': 'ion-happy-outline',
    'disabled': true,
    'hoverable': true
};
var _$tmp2 = {
    'className': 'ion-happy-outline',
    'disabled': true,
    'color': 'primary'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Icon, _$tmp0),
        _$cc(Icon, _$tmp1),
        _$cc(Icon, _$tmp2)
    ], 4);
};